
export default {
  data() {
    return {
      krakenProfile: {
        friends: [],
        inMatch: false,
        level: 0,
        lobby: null,
        match: null,
        matches: null,
        online: false,
        queue: false,
        session: false
      },
      krakenFriends: null,
      krakenMatch: null,
      krakenLobby: {
        host: {
          id: ''
        },
        users: [

        ]
      },
      hasLobby: false
    }
  },
  methods: {
    getKraken() {
      //
    },
    fetchFriends() {
      this.getKrakenFriends()
    }
  },
  created() {
    //
  }
}
